import React, {useState} from 'react'
import PropTypes from 'prop-types'


export default function TextForm(props) {
    const [text, setText] = useState('');

    const handleUpperClick = () => {
      let newText = text.toUpperCase();
        setText(newText);
      props.showAlert("Converted the UpperCase ! ", "success")
    }
    const handleLowerClick = () => {
      let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted the LowerCase! ", "success")
    }
    const handleCopyClick = () => {
      var text = document.getElementById("myBox");
      text.select();
      navigator.clipboard.writeText(text.value);
      document.getSelection().removeAllRanges();
      props.showAlert(" Your Text is Copied! ", "success")
    }
    const handleSpeakClick = () => {
      const utterance = new SpeechSynthesisUtterance(text);

      const voices = speechSynthesis.getVoices();

      const femaleVoice = voices.find(
      voice => voice.name === "Google UK English Female"
      );  
      utterance.voice = femaleVoice;
 // Select a voice (you can choose based on your preference)

      speechSynthesis.speak(utterance);
      props.showAlert("Text has been spoken! ", "success")
    }
    const handleDownloadClick = () => {
      const element = document.createElement("a");
      const file = new Blob([text], {type: 'text/plain'});
      element.href = URL.createObjectURL(file);
      element.download = "myText.txt";
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
      props.showAlert(" Your Text is Downloaded! ", "success")
    }
    const handleExtraSpaces = () => {
        let newText = text.split(/[ ]+/);// remove the extra spaces here
        setText(newText.join(" "));
       props.showAlert(" Extra Spaces is REMOVED! ", "success")
    }
    
    const handleOnChange = (event) => {
        setText(event.target.value);
    }
    return (
      <>
    <div className="container1" style={{color: props.mode === 'dark' ? 'white': '#042743'}}>
        <h1 classname="mb-4 ">{props.heading}</h1>
      <div className="mb-3">
        <textarea className="form-control" value={text} id="myBox" rows="9" onChange={handleOnChange} 
style={props.mode === 'dark' ? { backgroundColor: '#13466e', color: 'white' } : { backgroundColor: 'white', color: '#042743' }}></textarea>
      </div>
{/* here bootstrap class color: danger-red, primary-blue, success-green*/} 
      <button disabled={text.length === 0} className="btn btn-primary mx-2 my-1"  onClick={handleUpperClick}>Convert to Uppercase</button>
      <button disabled={text.length === 0} className="btn btn-primary mx-2 my-1" onClick={handleLowerClick}>Convert to Lowercase</button>
      <button disabled={text.length === 0} className="btn btn-primary mx-2 my-1" onClick={handleCopyClick}>Copy Text</button>
       <button disabled={text.length === 0} className="btn btn-primary mx-2 my-1" onClick={handleSpeakClick}>Speak</button>
       <button disabled={text.length === 0}  className="btn btn-primary mx-2 my-1" onClick={handleDownloadClick}>Download</button>
       <button disabled={text.length === 0} className="btn btn-primary mx-2 my-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
    </div>
    <div className="container2 my-3" style={{color: props.mode === 'dark' ? 'white' : '#042743'}}>
        <h3>Your text summary</h3>
{/* trim() removes spaces from the beginning and end of the text and split() breaks a string into an array of words and /\s+/ means:one or more spaces and filter() is used to remove empty elements from the array. The length property is used to count the number of words and characters in the text.*/}
        <p>{text.trim().split(/\s+/).filter((element)=>element.length!==0).length} words and {text.length} characters</p>
       
       <p><b>{0.008 * text.split(" ").filter((element)=>{return element.length!==0}).length} Minutes read</b></p>
       
        <h4>Preview: </h4>
        <p>{text.length>0 ? text : "Nothing to preview.. "}</p>
    </div>
    </>
  )
}

TextForm.propTypes = {
  heading: PropTypes.string.isRequired
}

TextForm.defaultProps = {
  heading: "Default Heading"
}

